import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import UserProfileApi from "@/api-client/api/services/userProfile/userProfile";
import { CalendarForm } from "../ui/calendarPicker";
import { format } from "date-fns";

export function PopUpEditRenter({
  trigger,
  relationship_id,
  fetchTenantRelationships,
}: {
  trigger: React.ReactNode;
  relationship_id: string;
  fetchTenantRelationships: () => void;
}) {
  const { t } = useTranslation();
  const [endDate, setEndDate] = useState<string>("");
  const [isOpen, setIsOpen] = useState(false);
  const [endDateError, setEndDateError] = useState("");

  const handleDialogClose = (isOpen: boolean) => {
    setIsOpen(isOpen);
  };

  const patchTenantRelationship = async () => {
    if (!endDate) {
      setEndDateError(t("popUpEditRenter.end_date_required"));
      return;
    }

    try {
      const response = await UserProfileApi.patchTenantRelationship({
        relationship_id,
        end_date: endDate,
      });
      fetchTenantRelationships();
      handleDialogClose(false);
      return response;
    } catch (error) {
      console.error("Error while creating news:", error);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleDialogClose} modal={false}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>

      {isOpen && (
        <div className="fixed inset-0 bg-black/10 backdrop-blur-[4px] z-40 pointer-events-none"></div>
      )}
      <DialogContent
        className="max-h-full overflow-auto gap-4 w-[440px] pb-[40px]"
        onInteractOutside={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader className="mb-[16px]">
          <DialogTitle className="text-[24px] font-medium flex items-center">
            {t("popUpEditRenter.editing_a_renter")}
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-2 items-end">
            <div className="w-full flex flex-col gap-2">
              <CalendarForm
                placeholder={t("popUpEditRenter.access_end_date")}
                setDueDate={(value) => {
                  setEndDate(value);
                  if (endDateError && value) {
                    setEndDateError("");
                  }
                }}
                prevDueDate={endDate ? format(endDate, "yyyy-MM-dd") : ""}
                size="big"
              />
              {endDateError && (
                <span className="text-red-500 text-sm">{endDateError}</span>
              )}
            </div>
          </div>

          <Button
            type="submit"
            variant="system"
            size="system"
            disabled={false}
            loading={false}
            onClick={patchTenantRelationship}
          >
            {t("confirm")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
